(function() { module.exports = this["lodash"]; }());